import FileSaver from 'file-saver';
import { deleteData, getData , getFile, postData, putData } from './index';

import {
  GET_ORDERS_LIST,
  ERROR_ORDERS,
  MESSAGE_ORDERS,
  GET_PRODUCTS_LIST,
  GET_ORDER,
  EXPORT_ORDERS,
  VALIDATE_ORDER,
  EXPORT_PROVIDER_ORDERS
} from "./types"

export async function getOrdersListAction(dispatch){
  let url = "/order"
  let offersList;
  await getData( ERROR_ORDERS, url, dispatch , true).then((response)=>{
    offersList = response.orders
  })
  dispatch({
    type : GET_ORDERS_LIST,
    payload : offersList
  })
}

export async function getProductsAction(dispatch){
  let url = "/product"
  let products;
  await getData( ERROR_ORDERS, url, dispatch , true).then((response)=>{
    products = response.products
  })
  dispatch({
    type : GET_PRODUCTS_LIST,
    payload : products
  })
}


export async function postOrderAction(dispatch , obj ){
  let url = "/order"
  let createOrder;
  await postData(MESSAGE_ORDERS , ERROR_ORDERS , url, dispatch , obj, true ).then((response)=>{
    createOrder = response
  });
  dispatch({
    type : MESSAGE_ORDERS,
    payload : createOrder.message
  })
}

export async function putOrderAction(dispatch , data, id){
  let url = "/order/" + id 
  let order;
  await putData( GET_ORDER, ERROR_ORDERS, url, dispatch, data , true).then((response)=>{
    order = response
  })
  dispatch({
    type : GET_ORDER,
    payload : order.order,
  });
  dispatch({
    type : MESSAGE_ORDERS,
    payload : order.message 
  })
}

export async function getOrderAction(dispatch , id){
  let url = "/order/" + id 
  let order;
  await getData( ERROR_ORDERS, url, dispatch , true).then((response)=>{
    order = response.order
  })
  dispatch({
    type : GET_ORDER,
    payload : order
  })
}

export async function deleteOrderAction(dispatch , id ){
  let url = "/order/" + id ;
  let orderDeleted;
  await deleteData( ERROR_ORDERS, url, dispatch , true).then((response)=>{
    orderDeleted = response;
  })
  return orderDeleted;
}



export async function exportOrdersAction(dispatch , obj ){
  let url = "/export/order"
  let exportList;
  await postData(EXPORT_ORDERS , ERROR_ORDERS , url, dispatch , obj, true ).then((response)=>{
    exportList = response
  });
  dispatch({
    type : EXPORT_ORDERS,
    payload : exportList
  })
}

export async function validateOrdersAction(dispatch , obj ){
  let url = "/order/validate"
  let validate;
  await postData(VALIDATE_ORDER , ERROR_ORDERS , url, dispatch , obj, true ).then((response)=>{
    validate = response
  });
  dispatch({
    type : VALIDATE_ORDER,
    payload : validate
  })
}

export async function exportProviderOrdersById(dispatch , id , name ){
  let url = `/order/export/fournisseur/${id}`
  let exportList;
  await getFile( ERROR_ORDERS, url, dispatch , true ).then((response)=> {
    var blob = new Blob([response], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,"});
    FileSaver.saveAs(blob, `commandes-${name}.xlsx`);
  });
  dispatch({
    type : EXPORT_PROVIDER_ORDERS,
    payload : exportList
  })
}